import { PayloadAction } from '@reduxjs/toolkit';

import { GalleryImage, GalleryState } from 'editor/src/store/gallery/types';
import getUploadInsertIndex from 'editor/src/store/gallery/utils/getUploadInsertIndex';

import { imageUuid } from './addImageReducer';

const addUploadedImagesReducer = (state: GalleryState, action: PayloadAction<Omit<GalleryImage, 'uuid'>[]>) => {
  const images = action.payload
    .filter((image) => !state.images.some((stateImage) => stateImage.id === image.id))
    .map((image) => ({ ...image, uuid: imageUuid.generate() }));
  // Pages of a split PDF already have the PDF's place in its upload batch; anything else goes on top.
  const isInUploadBatch = (image: GalleryImage) => !!state.uploadBatches?.some((ids) => ids.includes(image.id));
  state.images.unshift(...images.filter((image) => !isInUploadBatch(image)));
  images
    .filter(isInUploadBatch)
    .forEach((image) => state.images.splice(getUploadInsertIndex(state, image.id), 0, image));
};

export default addUploadedImagesReducer;
